module.exports = __webpack_public_path__ + "img/53_51.6621362d.png";